export default __webpack_public_path__ + "static/media/heineken.79b415d7.svg";